import Toast from "bootstrap/js/dist/toast";
// import Alert from "bootstrap/js/dist/alert";

export function collectCarOptionals(params) {
  // collect all checked values joined by "|" inside a input value
  const optionalsContainer = document.querySelector(".js-optional");

  optionalsContainer &&
    optionalsContainer.addEventListener("change", (event) => {
      console.log("change");
      const values = Array.from(
        optionalsContainer.querySelectorAll("input[type=checkbox]:checked")
      ).map((elem) => elem.value);
      console.log({ values });
      console.log(JSON.stringify(values));
      optionalsContainer.querySelector(".js-optional-data").value =
        JSON.stringify(values);
      console.log("new value:",optionalsContainer.querySelector(".js-optional-data").value);
    });
}

export function addElFromTemplate(selector, callback) {
  const container = document.querySelector(selector);
  let item = container
    .querySelector("template")
    .content.cloneNode(true).firstElementChild;
  if (callback) {
    item = callback(item);
  }
  container.appendChild(item);
  return item;
}

export function createToast(options) {
  const item = addElFromTemplate("#ajaxToast", (item) => {
    item.querySelector(".toast-body").innerText = options.message;
    item.classList.add(options.className);
    return item;
  });
  return new Toast(item);
}

export function goToFirstError(){
  const firsterror = document.querySelector(".errore");
  if (firsterror){
    firsterror.scrollIntoView({
      behavior: 'smooth'
    });
    return true;
  }
  return false;
}

export const domReady = (callBack) => {
  if (document.readyState === "loading") {
    document.addEventListener('DOMContentLoaded', callBack);
  }
  else {
    callBack();
  }
}
